import {CloseCircleFilled, PlusCircleOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import React, {FC} from 'react';

import {IGroupCompanyFormlistButtons} from 'pages/ais/organization-structure-v5/model/types';
import {ReactComponent as TrashX} from 'shared/assets/trash-x.svg';


export const GroupCompanyFormlistButtons: FC<IGroupCompanyFormlistButtons> = ({
    operations,
    fieldsList,
    selectedRows,
    setSelectedRows,
}: IGroupCompanyFormlistButtons) => (
    <section className="d-flex gap-2 mb-2">
        <Button
            type="primary"
            onClick={() => operations.add()}
        >
            <PlusCircleOutlined />
            Добавить
        </Button>
        <Button
            disabled={!selectedRows.length}
            type="primary"
            className="button-critic"
            onClick={() => {
                operations.remove(selectedRows);
                setSelectedRows([]);
            }}
        >
            <TrashX />
            Удалить выбранное
        </Button>
        <Button
            disabled={!fieldsList.length}
            type="primary"
            onClick={() => {
                operations.remove(fieldsList.map((field) => field.name));
                operations.add();
            }}
        >
            <CloseCircleFilled />
            Удалить все
        </Button>
    </section>
);
